export default __webpack_public_path__ + "static/media/aviao.63347ad8.jpg";